// API configuration
import { env } from "../env";

export const API_BASE_URL = env?.REACT_APP_BACKEND_URL || 'http://localhost:5000';

export const API_PREFIX = '/api/v1';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_PREFIX}/auth/login`,
    REGISTER: `${API_PREFIX}/auth/register`,
    LOGOUT: `${API_PREFIX}/auth/logout`,
    REFRESH_TOKEN: `${API_PREFIX}/auth/refresh-token`,
    RESET_PASSWORD: `${API_PREFIX}/auth/reset-password`,
    REQUEST_LOGIN_OTP: `${API_PREFIX}/auth/request-login-otp`,
    VERIFY_LOGIN_OTP: `${API_PREFIX}/auth/verify-login-otp`,
    FORGOT_PASSWORD: `${API_PREFIX}/auth/forgot-password`,
    VERIFY_PASSWORD_RESET_OTP: `${API_PREFIX}/auth/verify-password-reset-otp`,
    SET_NEW_PASSWORD: `${API_PREFIX}/auth/set-new-password`,
    VERIFY_REGISTRATION: `${API_PREFIX}/auth/verify-registration`,
    CHECK_EXISTING_SESSION: `${API_PREFIX}/auth/check-existing-session`,
    FORCE_LOGOUT_ALL_DEVICES: `${API_PREFIX}/auth/force-logout-all-devices`,
    LOGOUT_SPECIFIC_DEVICES: `${API_PREFIX}/auth/logout-specific-devices`,
    MY_SESSIONS: `${API_PREFIX}/auth/my-sessions`,
    LOGOUT_OTHER_DEVICES: `${API_PREFIX}/auth/logout-other-devices`,
    GET_USER_DETAILS: `${API_PREFIX}/auth/user-details`,
  },
  USERS: {
    BASE: `${API_PREFIX}/users`,
    PROFILE: `${API_PREFIX}/users/profile`,
    ORGANIZATION_PROFILE: `${API_PREFIX}/users/organization-profile`,
    ME: `${API_PREFIX}/auth/me`,
    SPENDING_SUMMARY: `${API_PREFIX}/wallet/feature-summary`,
  },
  PRODUCTS: {
    BASE: '/products',
    CATEGORIES: '/products/categories',
  },
  QNA: {
    INDEX_DOCUMENT: `${API_PREFIX}/ask_question/index-document`,
    ASK_QUESTION: `${API_PREFIX}/ask_question/ask`,
    GET_HISTORY: (documentId) => `${API_PREFIX}/ask_question/history/${documentId}`,
  },
  DOCUMENTS: {},
  FAST_DRAFTS: {
    BASE: `${API_PREFIX}/fastDrafts`,
    GET_ALL: `${API_PREFIX}/fastDrafts`,
    GET_BY_ID: (id) => `${API_PREFIX}/fastDrafts/${id}`,
    DRAFT_DOCUMENT: `${API_PREFIX}/fastDrafts/llm/draft_document`,
    DOWNLOAD_DOCX: `${API_PREFIX}/fastDrafts/download-docx`,
    DOWNLOAD_PDF: `${API_PREFIX}/fastDrafts/download-pdf`,
  },
  NEUROLOGICAL: {
    CHAT: `${API_PREFIX}/neurological/chat`,
  },
  DOCUMENT_REVIEW: {
    FollowUpQuestions: `${API_PREFIX}/document-review/review`,
    Review: `${API_PREFIX}/document-review/submit-answers`,
  },
  EVENT_EXTRACTION: {
    EXTRACT: `${API_PREFIX}/event-extraction/extract`,
    HEALTH: `${API_PREFIX}/event-extraction/health`,
  },
  LEGAL_VAULT: {
    BASE: `${API_PREFIX}/legal-vault`,
    FOLDERS: `${API_PREFIX}/legal-vault/folders`,
    FILES: `${API_PREFIX}/legal-vault/files`,
    UPLOAD: `${API_PREFIX}/legal-vault/upload`,
    SEARCH: `${API_PREFIX}/legal-vault/search`,
    DOWNLOAD: (id) => `${API_PREFIX}/legal-vault/download/${id}`,
    SHARE: (id) => `${API_PREFIX}/legal-vault/share/${id}`,
    MOVE: `${API_PREFIX}/legal-vault/move`,
    DELETE: (id) => `${API_PREFIX}/legal-vault/${id}`,
    RESTORE: (id) => `${API_PREFIX}/legal-vault/${id}/restore`,
    PERMANENT_DELETE: (id) => `${API_PREFIX}/legal-vault/permanent-delete/${id}`,
    RENAME: (id) => `${API_PREFIX}/legal-vault/${id}/rename`,
    MOVE_ITEM: (id) => `${API_PREFIX}/legal-vault/${id}/move`,
    STORAGE_STATS: `${API_PREFIX}/legal-vault/storage-stats`,
    STORAGE_RECALCULATE: `${API_PREFIX}/legal-vault/storage/recalculate`,
    AUDIT_LOGS: `${API_PREFIX}/legal-vault/audit`,
    TRASH: `${API_PREFIX}/legal-vault/trash`,
    SHARED: `${API_PREFIX}/legal-vault/shared`,
    HEALTH: `${API_PREFIX}/legal-vault/health`,
  },
    DRAFT_PRO: {
    UPLOAD: `${API_PREFIX}/draftpro/upload`,
    EXTRACT: `${API_PREFIX}/draftpro/extract-sections`,
    GENERATE: `${API_PREFIX}/draftpro/generate-draft`,
    GET_DETAILS: (id) => `${API_PREFIX}/draftpro/${id}`,
  },
};

export const API_TIMEOUT = 180000; 

export const API_HEADERS = {
  Accept: 'application/json',
};
